import { Distributors } from '../enums/Distributors';

import apexLogo from '../assets/logos/distributors/apex_industries_logo.svg';
import barilLogo from '../assets/logos/distributors/baril_logo.png';
import bourassaLogo from '../assets/logos/distributors/bourassa_laliberté_logo.png';
import citadelleLogo from '../assets/logos/distributors/citadelle_logo.png';
import dekLogo from '../assets/logos/distributors/dek_canada_logo.svg';
import drakkarLogo from '../assets/logos/distributors/drakkar_logo.jpeg';
import exitechLogo from '../assets/logos/distributors/exitech_logo.png';
import cfmLogo from '../assets/logos/distributors/groupe_cfm_logo.svg';
import andreLogo from '../assets/logos/distributors/industries_andre_logo.svg';
import lgLogo from '../assets/logos/distributors/portes_lg_logo.svg';
import longpreLogo from '../assets/logos/distributors/portes_longpres_logo.svg';
import universellesLogo from '../assets/logos/distributors/portes_universelles_logo.svg';
import rsmLogo from '../assets/logos/distributors/rsm_logo.jpg';
import ruelLogo from '../assets/logos/distributors/ruel_logo.jpg';
import simsLogo from '../assets/logos/distributors/sims_logo.svg';
import valmartLogo from '../assets/logos/distributors/valmart_logo.svg';

import {
    ANDRE_INDUSTRIES,
    APEX,
    BARIL,
    BOURASSA,
    CFM_GROUP,
    CITADELLE,
    DEK,
    DRAKKAR,
    EXITECH,
    LG_DOORS,
    LONGPRE_DOORS,
    RSM,
    RUEL,
    SIMS,
    UNIVERSAL_DOORS,
    VALMART,
} from './navigation/routeNames';

export const distributors = [
    {
        key: Distributors.APEX,
        logo: apexLogo,
        title: {
            fullName: 'apex_industries.full_name',
            firstPart: 'apex_industries.first_part',
            highlightedPart: 'apex_industries.highlighted_part',
        },
        linkTo: APEX,
        description: 'apex_industries.description',
        locations: [
            {
                address: '100 Millennium Blvd, Moncton, NB E1E 2G8, Canada',
                contact: '1-800-268-3331',
                coordinates: {
                    lat: 46.08998235588561,
                    lng: -64.80751178650614,
                },
            },
        ],
        webPage: 'apexindustries.com',
    },
    {
        key: Distributors.DEK,
        logo: dekLogo,
        title: {
            fullName: 'dek_canada.full_name',
            firstPart: 'dek_canada.first_part',
            highlightedPart: 'dek_canada.highlighted_part',
        },
        linkTo: DEK,
        description: 'dek_canada.description',
        locations: [
            {
                address: '154 Bd Brunswick, Pointe-Claire, QC',
                contact: '(514) 685-5800',
                coordinates: {
                    lat: 45.47007378233117,
                    lng: -73.82440746013738,
                },
            },
        ],
        webPage: 'dekcanada.com',
    },
    {
        key: Distributors.CFM_GROUP,
        logo: cfmLogo,
        title: {
            fullName: 'cfm_group.full_name',
            firstPart: 'cfm_group.first_part',
            highlightedPart: 'cfm_group.highlighted_part',
        },
        linkTo: CFM_GROUP,
        description: 'cfm_group.description',
        locations: [
            {
                address: '150 rue Maltais, Sept-Îles, QC, Canada, Quebec',
                contact: '418-962-0661',
                coordinates: {
                    lat: 50.2101989641263,
                    lng: -66.36683138690374,
                },
            },
        ],
        webPage: 'www.facebook.com/p/Groupe-CFM-100069907086089',
    },
    {
        key: Distributors.LG_DOORS,
        logo: lgLogo,
        title: {
            fullName: 'lg_doors.full_name',
            firstPart: 'lg_doors.first_part',
            highlightedPart: 'lg_doors.highlighted_part',
        },
        linkTo: LG_DOORS,
        description: 'lg_doors.description',
        locations: [
            {
                address: '1621 rue Comtois, Trois Rivières (Québec)',
                contact: '819-376-7527',
                coordinates: {
                    lat: 46.34055654675074,
                    lng: -72.56025798893485,
                },
            },
        ],
        webPage: 'porteslgrenovation.com',
    },
    {
        key: Distributors.ANDRE_INDUSTRIES,
        logo: andreLogo,
        title: {
            fullName: 'andre_industries.full_name',
            firstPart: 'andre_industries.first_part',
            highlightedPart: 'andre_industries.highlighted_part',
        },
        linkTo: ANDRE_INDUSTRIES,
        description: 'andre_industries.description',
        locations: [
            {
                address: '290, rue Rodolphe-Besner, Vaudreuil-Dorion',
                contact: '(450) 455-3585',
                coordinates: {
                    lat: 45.37439695836487,
                    lng: -74.04702611596102,
                },
            },
        ],
        webPage: 'portedegarageandre.com',
    },
    {
        key: Distributors.UNIVERSAL_DOORS,
        logo: universellesLogo,
        title: {
            fullName: 'universal_doors.full_name',
            firstPart: 'universal_doors.first_part',
            highlightedPart: 'universal_doors.highlighted_part',
        },
        linkTo: UNIVERSAL_DOORS,
        description: 'universal_doors.description',
        locations: [
            {
                address: '2628 Bernard‑Pilon, St‑Mathieu‑de‑Beloeil, QC J3G 4S5',
                contact: '450-600-2296',
                coordinates: {
                    lat: 45.57536288842769,
                    lng: -73.2567613447883,
                },
            },
        ],
        webPage: 'portesuniverselles.com',
    },
    {
        key: Distributors.LONGPRE_DOORS,
        logo: longpreLogo,
        title: {
            fullName: 'longpre_doors.full_name',
            firstPart: 'longpre_doors.first_part',
            highlightedPart: 'longpre_doors.highlighted_part',
        },
        linkTo: LONGPRE_DOORS,
        description: 'longpre_doors.description',
        locations: [
            {
                address: '400, rue des Adirondacks, Québec (Québec)',
                contact: '418-661-8801',
                coordinates: {
                    lat: 46.87980294013478,
                    lng: -71.18957543123844,
                },
            },
        ],
        webPage: 'longpreinc.ca',
    },
    {
        key: Distributors.SIMS,
        logo: simsLogo,
        title: {
            fullName: 'sims.full_name',
            firstPart: 'sims.first_part',
            highlightedPart: 'sims.highlighted_part',
        },
        linkTo: SIMS,
        description: 'sims.description',
        locations: [
            {
                address: '5915 40 St SE #16, Calgary, AB T2C 2H6, Canada',
                contact: '403-279-7455',
                coordinates: {
                    lat: 51.00042067001297,
                    lng: -113.97743069815232,
                },
            },
        ],
        webPage: 'simsoverheaddoors.com',
    },
    {
        key: Distributors.VALMART,
        logo: valmartLogo,
        title: {
            fullName: 'valmart.full_name',
            firstPart: 'valmart.first_part',
            highlightedPart: 'valmart.highlighted_part',
        },
        linkTo: VALMART,
        description: 'valmart.description',
        locations: [
            {
                address: '9644 192nd St, Surrey, BC',
                contact: '(604) 888-6116',
                coordinates: {
                    lat: 49.177960120663805,
                    lng: -122.68996945811624,
                },
            },
        ],
        webPage: 'valmartdoors.com',
    },
    {
        key: Distributors.DRAKKAR,
        logo: drakkarLogo,
        title: {
            fullName: 'drakkar.full_name',
            firstPart: 'drakkar.first_part',
            highlightedPart: 'drakkar.highlighted_part',
        },
        linkTo: DRAKKAR,
        description: 'drakkar.description',
        locations: [
            {
                address: '1520, Boul. Saint-Charles Drummonville (Québec) J2C 4Z5',
                contact: '(819) 478-2385',
                coordinates: {
                    lat: 45.90287178722624,
                    lng: -72.46015229815232,
                },
            },
            {
                address: '160 Rue Léger, Sherbrooke, QC J1L 1V9',
                contact: '819-566-7003',
                coordinates: {
                    lat: 45.38812,
                    lng: -71.87813,
                },
            },
        ],
        webPage: 'portesdrakkar.com',
    },
    {
        key: Distributors.BOURASSA,
        logo: bourassaLogo,
        title: {
            fullName: 'bourassa.full_name',
            firstPart: 'bourassa.first_part',
            highlightedPart: 'bourassa.highlighted_part',
        },
        linkTo: BOURASSA,
        description: 'bourassa.description',
        locations: [
            {
                address: '1447 Rue Nationale, Suite B, Terrebonne, QC J6W 6H8',
                contact: '(438) 801-9395',
                coordinates: {
                    lat: 45.717590773728396,
                    lng: -73.6118325640425,
                },
            },
        ],
        webPage: 'jsbourassa.com',
    },
    {
        key: Distributors.RUEL,
        logo: ruelLogo,
        title: {
            fullName: 'ruel.full_name',
            firstPart: 'ruel.first_part',
            highlightedPart: 'ruel.highlighted_part',
        },
        linkTo: RUEL,
        description: 'ruel.description',
        locations: [
            {
                address: '8540, Boulevard Bourque, Sherbrooke, QC J1N 0G2',
                contact: '819-200-1179',
                coordinates: {
                    lat: 45.37278,
                    lng: -71.96956,
                },
            },
            {
                address: '18165, avenue St-Louis, St-Hyacinthe, QC J2T 3H5',
                contact: '819-200-1179',
                coordinates: {
                    lat: 45.63076,
                    lng: -72.94913,
                },
            },
        ],
        webPage: 'rueletfils.com',
    },
    {
        key: Distributors.RSM,
        logo: rsmLogo,
        title: {
            fullName: 'rsm.full_name',
            firstPart: 'rsm.first_part',
            highlightedPart: 'rsm.highlighted_part',
        },
        linkTo: RSM,
        description: 'rsm.description',
        locations: [
            {
                address: '709, Route 219, Napierville, QC J0J 1L0',
                contact: '1-866-348-7402',
                coordinates: {
                    lat: 45.18685,
                    lng: -73.40482,
                },
            },
        ],
        webPage: 'portesrsm.com',
    },
    {
        key: Distributors.BARIL,
        logo: barilLogo,
        title: {
            fullName: 'baril.full_name',
            firstPart: 'baril.first_part',
            highlightedPart: 'baril.highlighted_part',
        },
        linkTo: BARIL,
        description: 'baril.description',
        locations: [
            {
                address: '500, boul. de la Bonaventure, Victoriaville, QC G6T 2E9',
                contact: '819 758-7538',
                coordinates: {
                    lat: 46.04928,
                    lng: -71.96214,
                },
            },
            {
                address: '1036A route de Fossambault, St-Augustin-de-Desmaures, QC G3A 1V1',
                contact: '418 871-8131',
                coordinates: {
                    lat: 46.74114,
                    lng: -71.38052,
                },
            },
        ],
        webPage: 'portesbaril.com',
    },
    {
        key: Distributors.EXITECH,
        logo: exitechLogo,
        title: {
            fullName: 'exitech.full_name',
            firstPart: 'exitech.first_part',
            highlightedPart: 'exitech.highlighted_part',
        },
        linkTo: EXITECH,
        description: 'exitech.description',
        locations: [
            {
                address: '26 rue de Valcourt, Gatineau, QC J8T 8G8',
                contact: '819-561-0135',
                coordinates: {
                    lat: 45.4921173,
                    lng: -75.70709,
                },
            },
        ],
        webPage: 'exitech.ca',
    },
    {
        key: Distributors.CITADELLE,
        logo: citadelleLogo,
        title: {
            fullName: 'citadelle.full_name',
            firstPart: 'citadelle.first_part',
            highlightedPart: 'citadelle.highlighted_part',
        },
        linkTo: CITADELLE,
        description: 'citadelle.description',
        locations: [
            {
                address: '1492 rue de Jaffa, Laval, QC H7P 4K9',
                contact: '450-622-7083',
                coordinates: {
                    lat: 45.6039846,
                    lng: -73.8069638,
                },
            },
        ],
        webPage: 'portecitadelle.com',
    },
].sort((a, b) => {
    var textA = a.title.fullName.toUpperCase();
    var textB = b.title.fullName.toUpperCase();

    return textA < textB ? -1 : textA > textB ? 1 : 0;
});
